<template>
  <!-- 综合查询 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="getDatas({}, 0)"
          >手动刷新</el-button
        >
      </div>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <div style="height: 0">
      <queryCondition
        ref="queryForm"
        :More="isHaseMore"
        :formConfig="queryCondditionDatas"
      ></queryCondition>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <!-- <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column> -->
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item.field == 'createStatusShow' && item.isShow"
          >
            <template slot-scope="scope">
              <div
                style="color: #f00"
                v-if="
                  scope.row.createStatus == 'sheng_cheng_error:create_status'
                "
              >
                {{ scope.row.createStatusShow }}
              </div>
              <div
                style="color: #ef7c0a"
                v-else-if="
                  scope.row.createStatus == 'sheng_cheng_zhong:create_status'
                "
              >
                {{ scope.row.createStatusShow }}
              </div>
              <div style="color: #00a846" v-else>
                {{ scope.row.createStatusShow }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="80px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                v-if="scope.row.fileId"
                class="rbtns"
                @click.stop="downFiles(scope.row)"
                >下载</el-button
              >
              <!-- <el-button v-else class="rbtns" disabled></el-button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
  </div>
</template>
<script>
import tableList from "@/pages/commonJS/tableList.js";
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
export default {
  mixins: [tableList],
  inject: ["reload"],
  components: {
    paging,
    queryBtns,
    queryCondition,
  },
  data() {
    return {
      pageGroupName: "excel_export_list", //  页面标识
      reportFiledsNumber: "excel_export_list", // 动态 条件、表头
      // command_list admin_waybill_posting_list
    };
  },
  mounted() {},
  activated() {
    this.queryBtn_ok();
  },
  watch: {},
  methods: {
    // 下载
    downFiles(row) {
      let fileNames = row.fileId || "";
      if (!fileNames) {
        this.$message.error("该文件生成失败,请重新操作导出");
        return false;
      }
      this.$API
        .wtl_downFile({ fileId: fileNames, fileName: row.fileName })
        .then((res) => {
          let data = res.data;
          // 获取响应的文件流数据
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          let url = URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = url;
          link.download = (row.fileName || "导出文件") + ".xlsx"; // 设置下载文件名
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(url); // 撤销URL对象
        });
    },
    getDatas() {
      this.queryBtn_ok();
    },
  },
};
</script>
<style scoped lang="less">
.glo_btnList_left {
  width: 100%;
  text-align: right;
}
</style>
